
import React from 'react'
import { string, array, oneOfType } from 'prop-types'

const Status = ({ color, status, children }) => { 
  return(<div className={`dif p4 aic ttu bgc-${color}-100 h16 fz11 fwb c-${color}-700 lts.4`}>{(status || children)}</div>)
}

export default Status

Status.propTypes = {
  color: string,
  status: string,
  children: oneOfType([
    string,
    array
  ])
}